import React from "react";

// Panneau de filtres repliable (piloté par la barre : aria-expanded/aria-controls).
// Les groupes s'enchaînent en ligne. Le pied porte la réinitialisation et la
// soumission du formulaire parent, et à gauche une information facultative
// (`footerInfo` : nombre de résultats, rappel). `inlineActions` place ces
// boutons au bout de la dernière ligne de champs (panneau de quelques champs) ;
// `showApply={false}` retire la soumission quand la barre de recherche porte
// déjà « Rechercher » et que le panneau reste ouvert.
const FilterPanel = ({
  id,
  open = true,
  title = "Filtres",
  children,
  onReset = null,
  canReset = true,
  resetLabel = "Réinitialiser les filtres",
  applyLabel = "Appliquer les filtres",
  isLoading = false,
  applyDisabled = false,
  footerInfo = null,
  inlineActions = false,
  showApply = true,
  className = "",
}) => {
  const actions =
    onReset || showApply ? (
      <div className="filter-panel__actions">
        {onReset && (
          <button type="button" className="btn btn-light" onClick={onReset} disabled={!canReset}>
            {resetLabel}
          </button>
        )}
        {showApply && (
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading || applyDisabled}
            aria-busy={isLoading || undefined}
          >
            {applyLabel}
          </button>
        )}
      </div>
    ) : null;
  return (
    <section
      id={id}
      className={`filter-panel${inlineActions ? " filter-panel--inline" : ""} ${className}`.trim()}
      hidden={!open}
      aria-label={title}
    >
      <div className="filter-panel__grid">
        {children}
        {inlineActions && actions}
      </div>
      {((!inlineActions && actions) || footerInfo) && (
        <div className="filter-panel__footer">
          {footerInfo && <div className="filter-panel__info">{footerInfo}</div>}
          {!inlineActions && actions}
        </div>
      )}
    </section>
  );
};

export default FilterPanel;
